import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.el.querySelectorAll('td').forEach((td) => {
            if (td.innerHTML.trim() === 'x') {
                td.innerHTML = '<span class="o-table-check"></span>';
            }
        });

        const table = this.el;
        const tableParent = this.el.parentNode.classList.contains("js-mobile-table");
        if (!tableParent) return;
        table.classList.add("is-mobile-table");
        const headers = Array.from(table.querySelectorAll("thead th")).map(th => {
            // Replace &nbsp; with spaces
            let html = th.innerHTML.replace(/&nbsp;/g, " ");

            // Add " | " after closing </strong> if it exists
            html = html.replace(/<\/strong>/i, '</strong> : ');

            // Remove all HTML tags and normalize whitespace
            return html
                .replace(/<[^>]*>/g, "")
                .trim()
                .replace(/\s+/g, " ");
        });

        table.querySelectorAll("tbody tr").forEach(row => {
            row.querySelectorAll("td").forEach((td, i) => {
                td.setAttribute("data-label", headers[i] || "");
            });
        });
    }
}
